import React from "react";
import "./circularTextOrbit.scss";
import CircleText from "../../molecules/circleText/circleText";
import "../../../styles/fontSizes.scss";
import "../../../styles/fontSizes.scss";
//Necesita que el padre tenga positicionamiento relativo.
//Recibe el tipo de órbita, limitado a la implementación del estilo del componente dentro de su hoja de estilo
const CircularTextOrbit = ({
  isOnFocus,
  textSize,
  rotation,
  text,
  bgColor,
  color,
}) => {
  return (
    <>
      <li
        style={{ transform: `rotateZ(${rotation}Deg)` }}
        className={` circular-text-o__container font-size--${textSize}`}
      >
        <CircleText
          isOnFocus={isOnFocus}
          bgColor={bgColor}
          color={color}
          rotation={-1 * rotation}
          className={`circular-text-o__text ${
            isOnFocus ? "circular-text-o__text--focus" : ""
          }`}
          text={text}
          textSize={textSize}
        />
      </li>
    </>
  );
};

export default CircularTextOrbit;
